export default __webpack_public_path__ + "static/img_welfare_7-44fc45b6398e324d6ab3de49d1c643d6.jpg";